/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ShiftiePlainDate } from './ShiftiePlainDate';
import {
    ShiftiePlainDateFromJSON,
    ShiftiePlainDateFromJSONTyped,
    ShiftiePlainDateToJSON,
    ShiftiePlainDateToJSONTyped,
} from './ShiftiePlainDate';

/**
 * 
 * @export
 * @interface UpdateEmployeePayData
 */
export interface UpdateEmployeePayData {
    /**
     * 
     * @type {number}
     * @memberof UpdateEmployeePayData
     */
    jobRoleId?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateEmployeePayData
     */
    payTypeId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateEmployeePayData
     */
    payCode?: string | null;
    /**
     * 
     * @type {ShiftiePlainDate}
     * @memberof UpdateEmployeePayData
     */
    startDate?: ShiftiePlainDate | null;
    /**
     * 
     * @type {ShiftiePlainDate}
     * @memberof UpdateEmployeePayData
     */
    endDate?: ShiftiePlainDate | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateEmployeePayData
     */
    mode?: UpdateEmployeePayDataModeEnum;
    /**
     * 
     * @type {number}
     * @memberof UpdateEmployeePayData
     */
    hourlyRate?: number;
}

/**
* @export
* @enum {string}
*/
export enum UpdateEmployeePayDataModeEnum {
    Fixed = 'Fixed',
    Percentage = 'Percentage'
}


/**
 * Check if a given object implements the UpdateEmployeePayData interface.
 */
export function instanceOfUpdateEmployeePayData(value: object): value is UpdateEmployeePayData {
    return true;
}

export function UpdateEmployeePayDataFromJSON(json: any): UpdateEmployeePayData {
    return UpdateEmployeePayDataFromJSONTyped(json, false);
}

export function UpdateEmployeePayDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateEmployeePayData {
    if (json == null) {
        return json;
    }
    return {
        
        'jobRoleId': json['jobRoleId'] == null ? undefined : json['jobRoleId'],
        'payTypeId': json['payTypeId'] == null ? undefined : json['payTypeId'],
        'payCode': json['payCode'] == null ? undefined : json['payCode'],
        'startDate': json['startDate'] == null ? undefined : ShiftiePlainDateFromJSON(json['startDate']),
        'endDate': json['endDate'] == null ? undefined : ShiftiePlainDateFromJSON(json['endDate']),
        'mode': json['mode'] == null ? undefined : json['mode'],
        'hourlyRate': json['hourlyRate'] == null ? undefined : json['hourlyRate'],
    };
}

  export function UpdateEmployeePayDataToJSON(json: any): UpdateEmployeePayData {
      return UpdateEmployeePayDataToJSONTyped(json, false);
  }

  export function UpdateEmployeePayDataToJSONTyped(value?: UpdateEmployeePayData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'jobRoleId': value['jobRoleId'],
        'payTypeId': value['payTypeId'],
        'payCode': value['payCode'],
        'startDate': ShiftiePlainDateToJSON(value['startDate']),
        'endDate': ShiftiePlainDateToJSON(value['endDate']),
        'mode': value['mode'],
        'hourlyRate': value['hourlyRate'],
    };
}

